/* eslint-disable @typescript-eslint/indent */
import type { AxiosInstance } from 'axios';

import type { TAxiosInterceptor } from '../../interfaces/IAxios';
import type { Functionize } from '../../interfaces/ITypes';

export const interceptResponse =
  (instance: AxiosInstance) =>
  (
    interceptor: Functionize<TAxiosInterceptor, AxiosInstance>,
  ): AxiosInstance => {
    const { response: responseHandler, error: errorHandler } =
      interceptor(instance);
    instance.interceptors.response.use(responseHandler, errorHandler);

    return instance;
  };
